import { useState } from "react";
import { faqs } from "@/mocks/chigua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <p className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600 mb-2">
            <span className="inline-block h-px w-8 bg-primary-400"></span>FAQ
            <span className="inline-block h-px w-8 bg-primary-400"></span>
          </p>
          <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题 · <span className="text-primary-600">带你快速入门</span>
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={
                  "overflow-hidden rounded-xl border transition-colors " +
                  (open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50/70")
                }
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className={"text-sm md:text-base font-semibold " + (open ? "text-primary-700" : "text-foreground-950")}>
                    {f.q}
                  </h3>
                  <span
                    className={
                      "flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-background-50 transition-transform duration-300 " +
                      (open ? "rotate-180 bg-primary-500" : "bg-background-300")
                    }
                  >
                    <i className="ri-arrow-down-s-line text-base"></i>
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed border-t border-background-200 pt-4">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}